import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Header, Footer } from "@/components/SiteChrome";
import api from "@/lib/api";

export default function BlogPost() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [nf, setNf] = useState(false);
    useEffect(() => { api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setNf(true)); }, [slug]);
    if (nf) return (
        <div className="min-h-screen bg-[hsl(var(--dust-50))]">
            <Header />
            <div className="mx-auto max-w-3xl px-4 py-32 text-center">
                <div className="font-display text-6xl uppercase italic">Post not found.</div>
                <Link to="/blog" className="mt-6 inline-block font-heading text-sm uppercase underline underline-offset-8">Back to journal</Link>
            </div>
            <Footer />
        </div>
    );
    if (!post) return null;
    return (
        <div className="min-h-screen bg-[hsl(var(--dust-50))]" data-testid="blog-detail-page">
            <Header />
            <article className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
                <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">Journal · {new Date(post.created_at).toLocaleDateString()}</div>
                <h1 className="mt-4 font-display text-5xl uppercase italic leading-tight text-[hsl(var(--ink))] md:text-6xl">{post.title}</h1>
                <p className="mt-6 text-lg text-[hsl(var(--ink-soft))]">{post.excerpt}</p>
                {post.cover_image && <img src={post.cover_image} alt={post.title} className="mt-8 aspect-[16/9] w-full border-2 border-[hsl(var(--ink))] object-cover" />}
                <div className="prose prose-lg mt-10 max-w-none font-sans text-[hsl(var(--ink))] [&_a]:text-[hsl(var(--forest))] [&_a]:underline [&_p]:my-4" dangerouslySetInnerHTML={{ __html: post.body }} />
            </article>
            <Footer />
        </div>
    );
}
